var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { defaultIconProps } from '../icon';
export var IconCaretUp = function (props) { return (_jsx("span", __assign({ className: "icon icon__caret-up ".concat(props.className) }, { children: _jsx("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M12.3931 10.4444C12.0743 10.7538 11.5673 10.7538 11.2486 10.4444L8 7.28995L4.75141 10.4444C4.43268 10.7538 3.92565 10.7538 3.60693 10.4444C3.27466 10.1217 3.27466 9.58833 3.60693 9.2657L7.30337 5.67643C7.69138 5.29967 8.30862 5.29967 8.69663 5.67643L12.3931 9.2657C12.7253 9.58833 12.7253 10.1217 12.3931 10.4444Z", fill: props.fill || defaultIconProps.fill }) })) }))); };
